import { render, staticRenderFns } from "./HORIZONTAL_SPACE.vue?vue&type=template&id=83e25cbe&scoped=true&"
import script from "./HORIZONTAL_SPACE.vue?vue&type=script&lang=js&"
export * from "./HORIZONTAL_SPACE.vue?vue&type=script&lang=js&"
import style0 from "./HORIZONTAL_SPACE.vue?vue&type=style&index=0&id=83e25cbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e25cbe",
  null
  
)

export default component.exports